// 8. 질문 3 - 영화 장르 (남윤)
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100dvh;
`;

export const ButtonContainer = styled.div`
  width: 90%;
  margin-top: 10px;
  margin-bottom: 2dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
`;
